import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeStatusCardComponent } from "../../components/ape-status-card/ape-status-card.component";
import { StatusCardData } from "../../components/ape-status-card/ape-status-card.component";

@Component({
  selector: "monitoring-details-counters-template",
  standalone: true,
  imports: [
    CommonModule,
    ApeStatusCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./monitoring-details-counters-template.component.html"
})
export class MonitoringDetailsCountersTemplateComponent {
  @Input()
  monitoringDetailsCountersCardData: StatusCardData[] = [];

  trackCardByIndex(index: number): number {
    return index;
  }
}
